// extracted by mini-css-extract-plugin
export default {"OnlineBooking":"OnlineBooking_OnlineBooking__62wcF","OnlineBookingFrame":"OnlineBooking_OnlineBookingFrame__ymyKS","OnlineBookingMobile":"OnlineBooking_OnlineBookingMobile__ZMnT2"};